export default __webpack_public_path__ + "static/media/satellite.7c84cbce.png";